import type { BadgeTone } from '@chopchop-se/ui';
import type { ReplenishmentDraftPoLine, ReplenishmentReason } from '@warehouse/shared';

/** Presentation logic for the replenishment work list — pure, so it is testable. */

const REASON_TONE: Record<ReplenishmentReason, BadgeTone> = {
  below_reorder_point: 'danger',
  below_min_stock: 'warning',
  days_cover: 'info',
};

export function reasonTone(reason: ReplenishmentReason): BadgeTone {
  return REASON_TONE[reason] ?? 'neutral';
}

/**
 * Days of cover, rounded for a table. `null` means the article has no
 * measurable consumption — which is NOT "0 days"; showing zero there would put
 * every dead article at the top of the urgency sort.
 */
export function daysCoverLabel(
  daysCover: number | null,
  t: (key: string, params?: Record<string, unknown>) => string,
): string {
  if (daysCover === null) return t('daysCover.unknown');
  const rounded = daysCover >= 10 ? Math.round(daysCover) : Math.round(daysCover * 10) / 10;
  return t('daysCover.value', { days: rounded });
}

/**
 * Selection → draft-PO lines. Rows the operator ticked but whose suggestion is
 * zero are dropped: a PO line for nothing is noise a buyer has to delete.
 */
export function selectedLines(selected: Record<string, string>): ReplenishmentDraftPoLine[] {
  return Object.entries(selected)
    .filter(([, qtyBase]) => Number(qtyBase) > 0)
    .map(([articleId, qtyBase]) => ({ articleId, qtyBase }));
}
